module.exports = __webpack_public_path__ + "image/TM_logo2.png";